<template>
  <component :is="layout">
    <router-view :key="$route.fullPath" />
  </component>
</template>

<script>
const defaultLayout = "login";

export default {
  computed: {
    layout() {
      const routeLayout = this.$route.meta.layout || defaultLayout;
      return `${routeLayout}-layout`;
    },
    isIdle() {
      return this.$store.state.idleVue.isIdle;
    }
  },
  data() {
    return {
      time: 599000, // 10 dakika (milisaniye cinsinden)
      timerId: null
    };
  },
  methods: {
    handleIdle() {
      clearInterval(this.timerId);

      this.$store.dispatch("logout");
      this.$store.dispatch("deletechat").then(() => {
        const validRoutes = [
          "individualSms",
          "individualLogin",
          "individualForget",
          "individualSignup",
          "corporateLogin"
        ];

        if (!validRoutes.includes(this.$route.name)) {
          this.$router.push({ name: "individualLogin" });
        }
      });
    }
  },
  watch: {
    isIdle: function (newIsIdle) {
      if (newIsIdle) {
        // Kullanıcı etkileşimde bulunmadığında
        this.handleIdle();
      } else {
        // Kullanıcı etkileşimde bulunduğunda
        this.time = 599000; // Zamanlayıcıyı resetle
      }
    }
  },
  created() {
    // Timer'ı başlat
    this.timerId = setInterval(() => {
      this.time -= 1000;
      if (!this.$store.state.idleVue.isIdle && this.time < 1) {
        this.handleIdle();
      }
    }, 1000);
  },
  beforeDestroy() {
    // Temizlik
    clearInterval(this.timerId);
  }
};
</script>



<style lang="scss">
@import "@/assets/scss/main.scss";

/* width */
::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>